<template>
  <div class="menu-ranking">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('menu.sequence') }}</strong>
            </div>
            <b-row>
              <b-col cols="12" class="text-center">
                <div class="pull-right">
                  <b-input-group v-bind:prepend="$t('menu.order_type')">
                    <b-form-select v-model="filter.order_type" :options="order_types[$session.get('lang')]" v-bind:placeholder="$t('menu.order_type')">
                    </b-form-select>
                  </b-input-group>
                </div>
                <div class="pull-right mr-2">
                  <b-input-group v-bind:prepend="$t('menu.display_date')">
                    <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                  </b-input-group>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="clientUuid === client_uuid.jp" style="border: 1px solid #c7c5c5; margin: 20px; padding: 10px;">
              <b-col cols="12" class="text-center">
                <draggable v-model="categories" @end="onEndCategory">
                  <transition-group class="category">
                    <div v-for="category in categories" :key="category.uuid" @click="updateCategory(category)" :class="category.uuid == selected_category.uuid ? 'active' : ''" v-if="category.status == 1">{{category.name[$session.get('lang')]}}</div>
                  </transition-group>
                </draggable>
              </b-col>
              <b-col cols="12" class="text-center" v-if="selected_category.lower_categories && selected_category.lower_categories.length > 0">
                <draggable v-model="selected_category.lower_categories" @end="onEndSubCategory">
                  <transition-group class="sub-category-with-btn">
                    <div v-for="subcategory in selected_category.lower_categories" :key="subcategory.uuid" @click="updateSubCategory(subcategory)" :class="subcategory.uuid == selected_sub_category.uuid ? 'active' : ''" v-if="subcategory.status == 1">{{subcategory.name[$session.get('lang')]}}</div>
                  </transition-group>
                </draggable>
              </b-col>
              <b-col cols="12">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" style="float: right;" v-on:click="updateSequenceJP">{{$t('category.update_sequence')}}</button>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col cols="12" class="text-center">
                <draggable v-model="categories" @end="onEndCategory">
                  <transition-group class="category">
                    <div v-for="category in categories" :key="category.uuid" @click="updateCategory(category)" :class="category.uuid == selected_category.uuid ? 'active' : ''" v-if="category.status == 1">{{category.name[$session.get('lang')]}}</div>
                  </transition-group>
                </draggable>
              </b-col>
              <b-col cols="12" class="text-center">
                <draggable v-model="selected_category.lower_categories" @end="onEndSubCategory">
                  <transition-group class="sub-category">
                    <div v-for="subcategory in selected_category.lower_categories" :key="subcategory.uuid" @click="updateSubCategory(subcategory)" :class="subcategory.uuid == selected_sub_category.uuid ? 'active' : ''" v-if="subcategory.status == 1">{{subcategory.name[$session.get('lang')]}}</div>
                  </transition-group>
                </draggable>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="text-center" v-for="(item , index) in items" :key="index+0">
              <h2 v-if="item.single_type"
                    class="watermark desktop cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr">
                  <img v-if="item.single_type.image && item.single_type.image.banner"
                       :src="item.single_type.image.banner"/>
                  <span class="fs-30 pr-7" v-else-if="item.single_type.name.hasOwnProperty($session.get('lang'))">{{item.single_type.name[$session.get('lang')]}} </span>
                  <span class="fs-30 pr-7" v-else>{{item.single_type.name}}</span>
              </h2>

                <draggable v-model="item.singles" @end="onEndProduct(index)">
                  <transition-group class="list-item-menu">
                    <div class="item-menu" v-for="single in item.singles" :key="single.uuid">
                      <div class="menu-image">
                        <img v-if="single['image'] != null && single['image']['desktop_thumbnail'] != null" :src="single['image']['desktop_thumbnail']">
                      </div>
                      <div class="menu-name">
                        <span v-if="single['name'] != null && single['name'][$session.get('lang')] != null">{{single['name'][$session.get('lang')]}}</span>
                      </div>
                      <div class="menu-description">
                        <span v-if="single['main_description'] != null && single['main_description'][$session.get('lang')] != null">{{single['main_description'][$session.get('lang')]}}</span>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </b-col>
            </b-row>
            <div slot="footer">
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="clientUuid === client_uuid.jp ? publicSequenceJP() : publicSequence()"> {{$t('common.publish')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  [draggable="true"] {
    /*
   To prevent user selecting inside the drag source
  */
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .category {
    list-style: none;
    overflow: hidden;
    margin: 0 !important;
    padding: 0 !important;
  }
  .category div {
    float: left;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    border-right: 1px solid #e9ebee !important;
    display: block;
    text-transform: uppercase;
    font-family: SharpSans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
    cursor: -webkit-grab;
    transition: all .5s;
  }
  .category div.active {
    background: #da291c;
    background-repeat: no-repeat;
    background-size: 70% 100%;
    color: #fff;
  }
  .sub-category {
    list-style: none;
    overflow: hidden;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    border-top: 1px solid #e9ebee;
  }
  .sub-category div {
    flex: 1;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    border-right: 1px solid #e9ebee !important;
    text-transform: uppercase;
    font-family: SharpSans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
    cursor: pointer;
    transition: all .5s;
  }
  .sub-category div.active {
    color: #da291c;
  }
  .sub-category-with-btn {
    list-style: none;
    overflow: hidden;
    margin: 0 0 20px !important;
    padding: 0 !important;
    display: flex;
    border-top: 1px solid #e9ebee;
    border-bottom: 1px solid #e9ebee;
    border-left: 1px solid #e9ebee;
  }
  .sub-category-with-btn div {
    flex: 1;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    border-right: 1px solid #e9ebee !important;
    text-transform: uppercase;
    font-family: SharpSans, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
    cursor: pointer;
    transition: all .5s;
  }
  .sub-category-with-btn div.active {
    color: #da291c;
  }
  .list-item-menu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 20px 0;
  }
  .list-item-menu .item-menu {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: calc(25% - 12px);
    position: relative;
    padding-bottom: 55px;
    cursor: move;
    background: white;
    border: 1px solid #eeedef;
    -webkit-box-shadow: 0 1px 1px -1px rgba(0,0,0,.6);
    box-shadow: 0 1px 1px -1px rgba(0,0,0,.6);
    margin: 6px;
    transition: all .5s;
  }
  .list-item-menu .item-menu:focus {
    background: #000 !important;
  }
  .list-item-menu .item-menu .menu-image {
    position: relative;
    background: #fdfdfd;
    overflow: hidden;
    background: url(https://static.phdvasia.com/jp/backgrounds/frontify_texture-concrete.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 168px;
  }
  .item-menu .menu-name {
    font-size: 15px;
    color: #000;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 10px 10px 6px;
  }
  .item-menu .menu-description {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 0px 10px;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #78838c;
    word-break: break-all;
  }
  .menu-ranking .btn-save{
    float: right;
    margin-right: 22px;
  }
  .menu-ranking .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .watermark img {
    width: 400px;
  }
</style>
<script>
import draggable from 'vuedraggable'
import axios from 'axios'
import DateRangePicker from 'vue2-daterange-picker'
const CancelToken = axios.CancelToken
let cancel = null

export default {
  name: 'MenuRanking',
  components: {
    draggable,
    DateRangePicker
  },
  data: function () {
    return {
      order_types: {},
      filter: {
        order_type: '0',
        startAt: this.$moment().format('YYYY-MM-DD') + ' 00:00:00',
        endAt: this.$moment().add(3, 'months').format('YYYY-MM-DD') + ' 00:00:00'
      },
      items: [],
      categories: [],
      selected_category: {},
      selected_sub_category: {},
      item: {},
      source: null,
      clientUuid: localStorage.getItem('clientID')
    }
  },
  methods: {
    updateSequenceJP () {
      let params = {
        categories: []
      }
      for (let i in this.categories) {
        params.categories.push({
          id: this.categories[i].id,
          sequence: this.categories[i].sequence
        })
      }
      for (let i in this.selected_category.lower_categories) {
        params.categories.push({
          id: this.selected_category.lower_categories[i].id,
          sequence: this.selected_category.lower_categories[i].sequence
        })
      }

      this.axios.menu.updateSequence(params, (response) => {
        let count = 0
        let max = 1
        this.axios.category.publishCategory(function (response) {
          count += 1
        })
        let flag = setInterval(() => {
          if (count >= max) {
            this.$toastr.success(this.$t('message.update_successful'), this.$t('message.success'), {})
            clearInterval(flag)
          }
        }, 500)
      })
    },

    publicSequenceJP () {
      let params = {
        products: []
      }

      for (let index in this.items) {
        for (let i in this.items[index]['singles']) {
          params.products.push({
            id: this.items[index]['singles'][i].id,
            sequence: this.items[index]['singles'][i].sequence,
            is_combo: this.items[index]['singles'][i].is_combo
          })
        }
      }
      this.axios.menu.updateSequence(params, (response) => {
        let count = 0
        let max = 1

        let comboIds = []
        let singleIds = []
        for (let index in this.items) {
          for (let i in this.items[index]['singles']) {
            if (this.items[index]['singles'][i].is_combo == 1) {
              comboIds.push(this.items[index]['singles'][i].id)
            } else {
              singleIds.push(this.items[index]['singles'][i].id)
            }
          }
        }
        if (comboIds.length > 0) {
          this.axios.menu.publishCombo({
            'scope': 'partial',
            'bulk': comboIds
          }, function (response) {
            count += 1
          })
        }
        if (singleIds.length > 0) {
          this.axios.menu.publishMenu({
            'scope': 'partial',
            'bulk': singleIds
          }, function (response) {
            count += 1
          })
        }
        
        let flag = setInterval(() => {
          if (count >= max) {
            this.$toastr.success(this.$t('message.update_successful'), this.$t('message.success'), {})
            clearInterval(flag)
          }
        }, 500)
      })
    },

    publicSequence () {
      this.updateSequence(() => {
        let count = 0
        let max = 1

        this.axios.category.publishCategory(function (response) {
          count += 1
        })
        let comboIds = []
        let singleIds = []
        for (let index in this.items) {
          for (let i in this.items[index]['singles']) {
            if (this.items[index]['singles'][i].is_combo == 1) {
              comboIds.push(this.items[index]['singles'][i].id)
            } else {
              singleIds.push(this.items[index]['singles'][i].id)
            }
          }
        }
        if (comboIds.length > 0) {
          max += 1
          this.axios.menu.publishCombo({
            'scope': 'partial',
            'bulk': comboIds
          }, function (response) {
            count += 1
          })
        }
        if (singleIds.length > 0) {
          max += 1
          this.axios.menu.publishMenu({
            'scope': 'partial',
            'bulk': singleIds
          }, function (response) {
            count += 1
          })
        }
        let flag = setInterval(() => {
          if (count >= max) {
            this.$toastr.success(this.$t('message.update_successful'), this.$t('message.success'), {})
            clearInterval(flag)
          }
        }, 500)
      })
    },
    
    updateSequence (cb) {
      let params = {
        categories: [],
        products: []
      }
      for (let i in this.categories) {
        params.categories.push({
          id: this.categories[i].id,
          sequence: this.categories[i].sequence
        })
      }
      for (let i in this.selected_category.lower_categories) {
        params.categories.push({
          id: this.selected_category.lower_categories[i].id,
          sequence: this.selected_category.lower_categories[i].sequence
        })
      }

      for (let index in this.items) {
        for (let i in this.items[index]['singles']) {
          params.products.push({
            id: this.items[index]['singles'][i].id,
            sequence: this.items[index]['singles'][i].sequence,
            is_combo: this.items[index]['singles'][i].is_combo
          })
        }
      }
      this.axios.menu.updateSequence(params, (response) => {
        cb()
      })
    },
    onEndCategory () {
      for (let i in this.categories) {
        this.categories[i]['sequence'] = i
      }
    },
    onEndSubCategory () {
      for (let i in this.selected_category.lower_categories) {
        this.selected_category.lower_categories[i]['sequence'] = i
      }
    },
    onEndProduct (index) {
      for (let i in this.items[index]['singles']) {
        this.items[index]['singles'][i]['sequence'] = i
      }
    },
    updateSubCategory (subcategory) {
      this.selected_sub_category = subcategory
      this.getItems()
    },
    updateCategory (category) {
      this.selected_category = category
      if (this.selected_category.lower_categories[0] != null) {
        this.selected_sub_category = this.selected_category.lower_categories[0]
      } else {
        this.selected_sub_category = {}
      }
      this.getItems()
    },
    getCategories () {
      this.axios.menu.getListDisplayCategories('level=1', (response) => {
        this.categories = response.data.data.items
        if (this.categories[0] != null) {
          this.selected_category = this.categories[0]
        }
        if (this.selected_category != null && this.selected_category != {}) {
          if (this.selected_category.lower_categories[0] != null) {
            this.selected_sub_category = this.selected_category.lower_categories[0]
          }
          this.getItems()
        }
      })
    },
    getItems () {
      let params = 'category_id=' + this.selected_category.id + '&status=1'
      params += '&is_single_type=1'
      switch (this.filter.order_type) {
        case '1':
          params += '&disposition=D'
          break
        case '2':
          params += '&disposition=C'
          break
        case '3':
          params += '&disposition=R'
          break
        default:
          params += '&disposition=C,D'
      }
      if (this.selected_sub_category.id == null) {
        console.log('SubCategory: NULL')
      } else {
        params += '&sub_category_id=' + this.selected_sub_category.id
      }
      params += `&start_date=${this.filter.startAt}&end_date=${this.filter.endAt}`

      this.items = []
      this.axios.menu.listMenuByCateogory(params, (response) => {
        this.items = response.data.data.items
      })
    },
    updateDateRange (val) {
      let startDate = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      let endDate = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.filter.startAt = startDate + ' 00:00:00'
      this.filter.endAt = endDate + ' 00:00:00'
      this.getItems()
    },
  },
  created: function () {
    let CancelToken = this.axios.CancelToken
    this.source = CancelToken.source()

    let langs = this.$store.getters.languages
    for (let l in langs) {
      this.order_types[langs[l]] = [
        {text: this.$t('common.all', langs[l]), value: '0'},
        {text: this.$t('common.delivery', langs[l]), value: '1'},
        {text: this.$t('common.takeaway', langs[l]), value: '2'}
      ]
      if (this.clientUuid && this.clientUuid === this.client_uuid.ph) {
        this.order_types[langs[l]].push({text: this.$t('common.dine-in', langs[l]), value: '3'})
      }
    }

    this.getCategories()
  },
  watch: {
    'filter.order_type': function (val) {
      this.getItems()
    }
  },
  computed : {
    date_locale : function () {
      let format = this.format_date_range_locale()
      if(this.$refs.drange){
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges : function () {
      return this.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/menu/Sequence.vue